import Host from "@interfaces/device/host"
import { useTranslation } from "react-i18next"

type HostItemRowProps = {
  host: Host
  changeHostShowSelected: () => void
}

const HostItemRow = (props: HostItemRowProps) => {
  const { t } = useTranslation(['myDevices'])

  return (
    <div className="Devices__HostItemInfo">
      <div className="Services__TableHeaderItem2">{t(`host.table.ip`)}: {props.host.host} </div>
      <div className="Services__TableHeaderItem2">{t(`host.table.protocol`)}: {props.host.protocol} </div>
      <div className="Services__TableHeaderItem2">{t(`host.table.port`)}: {props.host.port}</div>
      <div className="Services__TableHeaderItem2">{t(`host.table.context`)}: {props.host.context}</div>
    </div>
  )
}
export default HostItemRow
